'use client';

import NextImage from '@/components/ui/next-image';
import { event_error_boundry } from '@/utils/gtm';
import { useSearchParams } from 'next/navigation';
import { usePathname } from '@/i18n/navigation';
import NextLink from '@/components/next-link';
import { useLocale } from 'next-intl';
import { useEffect } from 'react';

export default function ErrorPage({ error, reset }) {
  const locale = useLocale();
  const pathname = usePathname();
  const searchQuery = useSearchParams();

  useEffect(() => {
    const pageTypes = {
      '/checkout': 'Checkout',
      '/cart': 'Cart',
      '/user': 'Account',
      '/blog': 'Blog',
      '/brands': 'Brand Page',
      '/': 'HP',
    };
    event_error_boundry(
      error?.message ||
        (locale == 'en' ? 'Something went wrong!' : 'حدث خطأ ما!'),
      pageTypes[pathname],
      pathname.includes('-c-') || pathname.includes('/product')
        ? document.title
        : pathname.includes('/search')
          ? `/search?q=${searchQuery.get('q')}`
          : pageTypes[pathname]
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className='flex min-h-screen flex-col items-center justify-center gap-8 max-md:gap-4'>
      <NextImage
        src='/imgs/not-found.png'
        width={640}
        height={260}
        alt='Not found image'
        className='size-[400px] object-contain'
      />
      <h2 className='text-3xl font-semibold max-md:text-base'>
        {locale == 'en' ? 'Something went wrong!' : 'حدث خطأ ما!'}
      </h2>
      <div className='flex gap-4'>
        <button
          aria-label='Error Button'
          onClick={reset}
          className='bg-primary hover:bg-primary/80 w-60 cursor-pointer rounded-md p-2 text-center font-bold text-white uppercase transition-all max-md:text-xs'
        >
          {locale == 'en' ? 'Try again' : 'حاول مره أخرى'}
        </button>
        <NextLink
          href={'/'}
          className={`hover:bg-primary text-primary border-primary w-60 rounded-md border bg-white p-2 text-center font-bold uppercase transition-all hover:text-white max-md:text-sm max-sm:text-xs`}
        >
          {locale === 'en' ? 'Back to Home' : 'العودة إلى الرئيسية'}
        </NextLink>
      </div>
    </div>
  );
}
